import { FC } from 'react';
import styles from './banner.module.css';
import Grid from '@mui/material/Grid';
import { Box, Container, Typography } from '@mui/material';
import { ChatContainer } from '../chat/chat.container';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

export interface BannerProps {
  imageBanner: string;
}

export const Banner: FC<BannerProps> = ({ imageBanner }) => {
  return (
    <div className={styles.xviaBannerContainer}>
      <div
        className={styles.xviaBanner}
        style={{
          backgroundImage: `url("${imageBanner}")`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className={styles.xviaBannerContent}>
          <Container>
            <Grid container mt={{ xs: 2, sm: 6 }}>
              <Grid
                item
                xs={12}
                md={7}
                display="flex"
                flexDirection="row"
                justifyContent={{ xs: 'center', md: 'flex-start' }}
                marginTop={{ xs: 2, sm: 8 }}
                marginBottom={{ xs: 2, sm: 10 }}
                order={{ xs: 1, md: 1 }}
              >
                <Box
                  sx={{
                    background: '#00d2dc',
                    width: { xs: 4, sm: 10 },
                    mr: { xs: 0, sm: 0 },
                    flexShrink: 0,
                    height: '100%',
                    borderRadius: { xs: '10px 0 0 10px', sm: '10px 0 0 10px' },
                    minHeight: { xs: 0, sm: 'auto' },
                    position: 'relative',
                    zIndex: 1,
                  }}
                ></Box>
                <Box
                  sx={{
                    background:
                      'linear-gradient(135deg, rgba(74,56,103,0.9) 0%, rgba(57,69,121,0.9) 100%)',
                    color: '#fff',
                    paddingLeft: { xs: 2, sm: 4 },
                    justifyContent: 'space-around',
                    display: 'flex',
                    flexDirection: 'column',
                    width: { xs: 'calc(100% - 4px)', sm: '140%', lg: '728px' },
                    flexGrow: 1,
                    height: { xs: '260px', lg: '320px' },
                    paddingRight: { xs: 4, sm: 24 },
                    position: 'relative',
                    zIndex: 0,
                  }}
                >
                  {/*<img         src={`${process.env.PUBLIC_URL}/images/ia.gif`}/>*/}
                  <img
                    data-testid="banner-logo"
                    src={`${process.env.PUBLIC_URL}/images/es-gov-vazado.svg`}
                    style={{
                      maxWidth: '200px',
                      height: 'auto',
                      marginLeft: '-0.5em',
                      marginBottom: '-1em',
                    }}
                    alt={'ES Governo'}
                  />
                  <Typography
                    color="#FDFDFD"
                    variant="h4"
                    sx={{
                      fontFamily: 'Montserrat',
                      fontWeight: 800,
                      fontSize: { xs: '20px', sm: '40px' },
                      lineHeight: { xs: '26px', sm: '50px' },
                      letterSpacing: '1px',
                      verticalAlign: 'middle',
                      color: '#FDFDFD',
                      mb: { xs: -3, sm: -7 },
                      whiteSpace: 'nowrap',
                    }}
                  >
                    Olá, seja bem-vindo!
                  </Typography>
                  <Typography
                    color="#FDFDFD"
                    variant="h6"
                    sx={{
                      fontFamily: 'Montserrat',
                      fontWeight: 700,
                      fontSize: { xs: '14px', sm: '22px' },
                      lineHeight: { xs: '18px', sm: '28px' },
                      letterSpacing: '2px',
                      verticalAlign: 'middle',
                      color: '#FDFDFD',
                      mb: { xs: -2, sm: -5 },
                    }}
                  >
                    Você está no portal oficial do Estado do Espírito Santo
                  </Typography>
                  <Box display="flex" alignItems="center">
                    <Typography
                      color="#FDFDFD"
                      variant="subtitle2"
                      sx={{
                        fontFamily: 'Montserrat',
                        fontWeight: 500,
                        fontSize: { xs: '12px', sm: '18px' },
                        lineHeight: { xs: '16px', sm: '24px' },
                        letterSpacing: '0.46px',
                        verticalAlign: 'middle',
                        color: '#FDFDFD',
                      }}
                    >
                      Converse com a Lia para saber mais
                    </Typography>
                    <Box sx={{ display: 'flex', ml: 1 }}>
                      {[...Array(4)].map((_, i) => (
                        <ChevronRightIcon
                          key={i}
                          sx={{
                            color: '#FDFDFD',
                            fontSize: { xs: 16, sm: 24 },
                            ml: i === 0 ? 0.5 : '-10px',
                          }}
                        />
                      ))}
                    </Box>
                  </Box>
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                md={5}
                order={{ xs: 1, md: 2 }}
                sx={{
                  display: 'flex',
                  justifyContent: { xs: 'center', md: 'flex-end' },
                  alignItems: { xs: 'center', md: 'flex-start' },
                  mt: { xs: 1, md: 0 },
                  mb: { xs: 3, md: 0 },
                  width: '100%',
                  px: { xs: 1, sm: 0 },
                  maxHeight: { xs: '100%', sm: '100%', md: 292, lg: 292 },
                }}
              >
                <Box
                  sx={{
                    width: { xs: '100%', sm: 400, md: 488 },
                    minWidth: { md: 488 },
                    maxHeight: { xs: '100%', sm: '100%', md: 292, lg: 292 },
                    mx: { xs: 0, sm: 0 },
                  }}
                >
                  <ChatContainer />
                </Box>
              </Grid>
            </Grid>
          </Container>
        </div>
      </div>
    </div>
  );
};
